import SsoDialogType from '../enums/SsoDialogType';

interface ActiveSsoDialog {
    type: SsoDialogType;
    isOpen: boolean;
    isVisible: boolean;
    authChallenge: string;
    controlId?: string;
}

export function createHiddenSsoDialog(): ActiveSsoDialog {
    return {
        isOpen: false,
        isVisible: false,
        controlId: null,
        type: SsoDialogType.None,
        authChallenge: null,
    };
}

export function createVisibleSsoDialog(
    controlId: string,
    type: SsoDialogType,
    authChallenge: string
): ActiveSsoDialog {
    return {
        isOpen: true,
        isVisible: type == SsoDialogType.OmexConsent ? false : true,
        controlId: controlId,
        type: type,
        authChallenge: authChallenge,
    };
}

export default ActiveSsoDialog;
